import { BsHouseDoor } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { ADMIN, DASHBOARD, PROPOSAL } from "../../constants/routes";
import { formatDate } from "../../helpers/helpers";
import P from "../../shared/typography/P";
const ProposalList = ({ data }) => {
    const history = useHistory();

    return (
        <div className="font-vietnam">
            {data.map((item) => (
                <div
                    key={item?.plantId}
                    role="button"
                    onClick={() =>
                        item?.count > 0
                            ? history.push(`${PROPOSAL}/${item.plantId}`)
                            : history.push(
                                  `${ADMIN}${DASHBOARD}/generate/${item.plantId}`
                              )
                    }
                    className="py-2 border-b border-b-blue-300 flex flex-col gap-0.8"
                >
                    <div className="flex justify-between items-center">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem",
                            }}
                        >
                            <span style={{ fontSize: "20px" }}>
                                <BsHouseDoor />
                            </span>
                            <P className="text-xs  xs:text-sm sm:text-xs xl:text-xs line-clamp-1 font-semibold">
                                {item?.name}
                            </P>
                        </div>
                        <P className="text-nowrap text-xs xs:text-sm sm:text-xs xl:text-xs line-clamp-1 font-semibold">
                            {item?.assignee}
                        </P>
                    </div>
                    <div className="flex justify-between mt-0.5">
                        <div>
                            <P className="text-xs sm:text-xs xl:text-xs text-gray-370">
                                {item?.plantId} &nbsp;{" "}
                                {formatDate(item?.creationDate)}
                            </P>
                        </div>
                        <div>
                            <P className="text-xs sm:text-xs xl:text-xs text-gray-370">
                                Proposal: {item?.count}
                            </P>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProposalList;
